// src/admin/ChangePassword.js
import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import axios from 'axios';
import BASE_URL from '../config';

const ChangePassword = () => {
  const email = sessionStorage.getItem('adminEmail'); // store this on login
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleChange = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASE_URL}/api/admin/change-password`, {
        email,
        oldPassword,
        newPassword,
      });
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error updating password');
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Typography variant="h6" gutterBottom>Change Password</Typography>
      <Box component="form" onSubmit={handleChange}>
        <TextField
          fullWidth
          type="password"
          label="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          required
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          type="password"
          label="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
          Update Password
        </Button>
        {message && (
          <Typography sx={{ mt: 2 }} color="primary">{message}</Typography>
        )}
      </Box>
    </Container>
  );
};

export default ChangePassword;
